<h1 mat-dialog-title>{{data.idPlan.length > 0 ? data.idPlan + '. ' : ''}} {{data.name.length > 0 ? data.name : data.contactName}}</h1>
<div mat-dialog-content class="stand-card">

  <!-- <mat-card-title>{{data.idPlan.length > 0 ? data.idPlan + '. ' : ''}} {{data.name.length > 0 ? data.name : data.contactName}}</mat-card-title>
  <mat-card-subtitle>{{data.activity}}</mat-card-subtitle> -->

  {{ data.comment | nl2br }}

  <!-- <mat-divider></mat-divider> -->

  <mat-list dense>
    <mat-list-item *ngIf="data.contactName">
      <mat-icon matListIcon style="color: #2E3D99">contacts</mat-icon>
      <h3 matLine>{{ data.contactName }}</h3>
    </mat-list-item>
    <mat-list-item *ngIf="data.phone">
      <mat-icon matListIcon style="color: #2E3D99">call</mat-icon>
      <h3 matLine><a href="tel:{{data.phone}}">{{data.phone}}</a></h3>
    </mat-list-item>
    <mat-list-item *ngIf="data.email">
      <mat-icon matListIcon style="color: #2E3D99">email</mat-icon>
      <h3 matLine><a href="mailto:{{data.email}}">{{data.email}}</a></h3>
    </mat-list-item>
    <mat-list-item *ngIf="data.website">
      <mat-icon matListIcon style="color: #2E3D99">language</mat-icon>
      <h3 matLine><a href="{{data.website}}" target="_blank">{{ (data.website.length > 60) ? (data.website | slice:0:60)+'...' : data.website}}</a></h3>
    </mat-list-item>

    <mat-list-item *ngIf="data.delivery === true">
      <mat-icon matListIcon svgIcon="truck-fast-outline" style="color: #2E3D99"></mat-icon>
      <h3 matLine>Réalise des livraisons</h3>
    </mat-list-item>
    <mat-list-item *ngIf="data.delivery === false">
      <mat-icon matListIcon svgIcon="truck" style="color: #2E3D99"></mat-icon>
      <h3 matLine>Ne réalise pas de livraisons</h3>
    </mat-list-item>
    <mat-list-item *ngIf="data.delivery === true && data.deliveryDays.length > 0">
      <mat-icon matListIcon svgIcon="calendar" style="color: #2E3D99"></mat-icon>
      <h3 matLine>Jours de livraison : {{ data.deliveryDays }}</h3>
    </mat-list-item>

    <mat-list-item *ngIf="data.orderByPhone === true">
      <mat-icon matListIcon svgIcon="phone-check" style="color: #2E3D99"></mat-icon>
      <h3 matLine>Prend les commandes par téléphone</h3>
    </mat-list-item>
    <mat-list-item *ngIf="data.orderByEmail === true">
      <mat-icon matListIcon svgIcon="email-check" style="color: #2E3D99"></mat-icon>
      <h3 matLine>Prend les commandes par email</h3>
    </mat-list-item>
  </mat-list>
</div>
<div mat-dialog-actions>
  <button mat-button (click)="onNoClick()">Fermer</button>
  <!-- <button mat-button [mat-dialog-close]="data.animal" cdkFocusInitial>Ok</button> -->
</div>